'use strict';
import modalController from './obtenerSiprunModal.controller.js';
import modalTemplate from './obtenerSiprunModal.html';

class OperacionesCorteMensual {
  constructor ($location, DataService, Message, Modal, $scope, Storage, $log, $state, NgTableParams, Loading) {
    'ngInject';
    this.NgTableParams = NgTableParams;
    this.$location = $location;
    this.DataService = DataService;
    this.Message = Message;
    this.Modal = Modal;
    this.$scope = $scope;
    this.Storage = Storage;
    this.rol = this.Storage.getUser().rol;
    this.$log = $log;
    this.$state = $state;
    this.Loading = Loading;
    this.months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  }

  $onInit () {
    this.disable = false;
    this.fechaActual = new Date();
    this.mes = this.fechaActual.getMonth() + 1;
    this.gestion = this.fechaActual.getFullYear();
    this.month = this.months[this.mes-1];
    this.obtenerDetalleControlCorte();
  }

  volverControlCorte () {
    this.$location.path(`/operaciones_mensual`);
  }

  obtenerDetalleControlCorte () {
    this.DataService.get(`centralizador/control_corte/detalle_control_corte?tipo=MENSUAL`)
      .then((response) => {
        if (response) {
          if (response && response.datos && response.datos.pasos) {
            this.detalleControlCorteMensual = response.datos;
            this.operaciones = JSON.parse(response.datos.pasos);
          }
          if (response && response.datos && response.datos.detalleCorteAnterior) {
            this.detalleControlCorteMensual = response.datos.detalleCorteAnterior;
            this.operaciones = JSON.parse(response.datos.detalleCorteAnterior.pasos);
            this.month = this.months[response.datos.detalleCorteAnterior.mes - 1];
          }
        }
        return this.operaciones;
      });
  }

  actualizarProceso (orden, proceso) {
    this.$log.log('Orden', orden, typeof orden)
    this.$log.log('Proceso', proceso)
    let mensajeProceso = `<p><b>PROCESO: </b> ${proceso}</p>`
    mensajeProceso = orden == 8 ? 
      mensajeProceso + ` <div class="alert col-md-12 alert-info"> El modulo de soporte se inhabilitará a partir de la ejecución de este paso. </div> ` 
      : mensajeProceso
    this.Modal.confirm(mensajeProceso, () => {
    this.disable = true;
    this.DataService.put(`centralizador/control_corte/actualizar_control_corte/${this.detalleControlCorteMensual.id_control_corte}`, { orden, tipo: 'MENSUAL' })
      .then(response => {
        if (response && response.finalizado) {
          let url = this.operaciones[orden - 1].api;
          let tipo = this.operaciones[orden - 1].tipo;
          this.Loading.show(`Este proceso del corte puede demorar, <br>sea paciente por favor...`, true);
          if (tipo == 'POST') {
            this.DataService.post(url) 
            .then(response2 => {
              this.Loading.hide();
              if (response2.finalizado) {
                this.Message.success(response2.mensaje);
                this.$state.reload();
              } else {
                this.Message.error(response2.mensaje);
              }
            });
          } else {
            this.DataService.get(url) 
             .then(response3 => {
              this.Loading.hide();
              if (response3.finalizado) {
                this.Message.success('ok');
                this.$state.reload();
              } else {
                this.Message.error(response3.mensaje);
              }
            });
          }
        } else {
          this.Message.error('Ocurrió un error mientras se realizaba la ejecución del servicio.');
        }
      });
    }, () => {}, '¿Esta seguro de ejecutar el siguiente proceso?', 'Confirmar', 'Cancelar', '-', 'lg');
  }

  obtener () {
    this.Modal.show({
      template: modalTemplate,
      controller: modalController,
      data: '',
      size: 'md'
    });
  }
}

export default OperacionesCorteMensual;



// WEBPACK FOOTER //
// ./src/app/components/operaciones/corteMensual/operacionesCorteMensual.controller.js